export enum STREAM_URL_TYPE {
    PREMIUM = 'premium',
    FREE = 'tazzfree',
}

export const STREAM_HOST_BY_TYPE = {
    [STREAM_URL_TYPE.PREMIUM]: 'cds.newtazz.com',
    [STREAM_URL_TYPE.FREE]: 'minum.realiptvs.com',
}

export const CHANNELS_LEAGUE_IDS = ['a68c1287', '71026664']
export const STREAM_FILTER_PARAM = 'tazz'
export const EXCLUDE_FROM_CHANNEL_NAME = '_tazz'
